module.exports = __webpack_public_path__ + "img/news-list-top-bg.e0cd17f1.png";